import { LOADING, ERROR, CLEAR_ERRORS } from '../constants/globalConstants'
import {
  ADD_SONG,
  GET_SONGS,
  SEARCH_SONGS,
  GET_SONG,
  EDIT_SONG,
  DELETE_SONG
} from '../constants/songConstants'

const songReducer = (state = {}, action) => {
  switch (action.type) {
    case CLEAR_ERRORS:
      return { ...state, loading: false, error: null }

    case LOADING:
      return { ...state, loading: true }

    case ERROR:
      return { ...state, loading: false, error: action.payload }

    case ADD_SONG:
      return { ...state, loading: false, error: null }

    case GET_SONGS:
      return { ...state, loading: false, error: null, songs: action.payload }

    case SEARCH_SONGS:
      return { ...state, loading: false, error: null, searchedSongs: action.payload }

    case GET_SONG:
      return { ...state, loading: false, error: null, song: action.payload }

    case EDIT_SONG:
      return { ...state, loading: false, error: null }

    case DELETE_SONG:
      return { ...state, loading: false, error: null, song: null, songs: state.songs.filter(song => song._id !== action.payload) }

    default:
      return state
  }
}

export default songReducer